import { Avatar, Button, Col } from "antd";
import { DeleteOutlined } from "@ant-design/icons";

import Table from "../../../shared/components/ui/Table";
import { useKitsProducts, useTableKitsProducts } from "../hooks";
import { ISingleProductForKit } from "../hooks/useKitsProducts";
import { TableColumns } from "../../../shared/components/ui/Table/types";
import { kitsProductsService } from "../../../shared/services";
import { PATH_S3_BUCKET } from "../../../shared/utils/constants";

export const TableKitsProducts = () => {
  const { showDeleteConfirm } = useTableKitsProducts();
  const { setTableProps, id } = useKitsProducts();

  const columns: TableColumns<ISingleProductForKit> = [
    {
      title: "ID",
      width: 3,
      dataIndex: "id",
      key: "id",
      filterType: "text",
    },
    {
      title: "Imagen",
      width: 4,
      dataIndex: ["product", "main_image"],
      key: "main_image",
      render: (_, item) => {
        const path = item.product?.main_image;
        if (!path) return null;
        return (
          <Avatar
            shape="square"
            size={56}
            src={`${PATH_S3_BUCKET}/${path}`}
          />
        );
      },
    },
    {
      title: "Producto",
      width: 10,
      dataIndex: ["product", "name"],
      key: "name",
    },
    {
      title: "Cantidad",
      width: 5,
      dataIndex: "quantity",
      key: "quantity",
    },
    {
      title: "Stock",
      width: 5,
      dataIndex: ["product", "quantity"],
      key: "stock",
      render: (_, item) => {
        const stock = Number(item.product?.quantity ?? 0);
        const needed = Number(item.quantity ?? 1);
        const ok = Number.isFinite(stock) && stock >= needed;
        return (
          <span style={{ color: ok ? undefined : "#cf1322", fontWeight: ok ? 400 : 600 }}>
            {Number.isFinite(stock) ? stock : "—"}
            {!ok ? " (sin stock)" : ""}
          </span>
        );
      },
    },
    {
      title: "Acciones",
      key: "operation",
      fixed: "right",
      width: 3,
      render: (_, item) => {
        return (
          <Col
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-evenly",
              flexDirection: "row",
            }}
          >
            <Button
              type="primary"
              danger
              onClick={() =>
                showDeleteConfirm(item.id, `${item.product?.name ?? item.id}`)
              }
              shape="circle"
              icon={<DeleteOutlined />}
              size="large"
            />
          </Col>
        );
      },
    },
  ];

  return (
    <Table<ISingleProductForKit>
      columns={columns}
      fetchQueryProps={{
        kit_id: id,
        $sort: { id: -1 },
      }}
      service={kitsProductsService}
      onLoad={setTableProps}
    />
  );
};
